<template>
  <div class="info-button-new" @click="newInfo">
    新しいお知らせの作成
  </div>
</template>

<script>
export default {
  methods: {
    newInfo: function () {
      this.$router.push('/info/new')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-button-new {
  @include button-ol-primary;
}
</style>
